
{
  "title": "探索服务",
  "searchPlaceholder": "搜索服务...",
  "sortBy": "排序方式",
  "sortOptions": {
    "featured": "精选",
    "rating": "评分最高",
    "reviews": "评价最多",
    "nameAsc": "名称 A-Z",
    "nameDesc": "名称 Z-A"
  },
  "filters": {
    "category": "类别",
    "location": "位置",
    "rating": "评分",
    "clearAll": "清除全部"
  },
  "providers": {
    "loading": "加载服务提供者中...",
    "providerCount": "找到 {{count}} 个服务提供者",
    "provider": "服务提供者",
    "loadMore": "加载更多",
    "searchResults": "「{{query}}」的搜索结果",
    "categoryResults": "{{category}} 服务",
    "favoriteResults": "您收藏的服务提供者",
    "noResults": {
      "title": "未找到服务提供者",
      "description": "尝试调整您的搜索或筛选条件以找到您要找的内容。"
    }
  }
}
